import { render, staticRenderFns } from "./LpuCards.vue?vue&type=template&id=37335952&"
import script from "./LpuCards.vue?vue&type=script&lang=ts&setup=true&"
export * from "./LpuCards.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37335952')) {
      api.createRecord('37335952', component.options)
    } else {
      api.reload('37335952', component.options)
    }
    module.hot.accept("./LpuCards.vue?vue&type=template&id=37335952&", function () {
      api.rerender('37335952', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/info/shame-mark/ShameMarkContent/components/LpuCards.vue"
export default component.exports